import EntityContentForm from './EntityContentForm';

export default EntityContentForm;
